var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.821,
    height: 11.632,
    viewBox: "0 0 11.821 11.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 11.821,
    height: 11.632,
    fill: "#2e343d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M0,20.888q0-1.847,0-3.694A1.717,1.717,0,0,1,1.39,15.475a1.947,1.947,0,0,1,.378-.036c1.078,0,2.155,0,3.233,0a.585.585,0,0,1,.57.319.567.567,0,0,1-.382.814,1.023,1.023,0,0,1-.218.019H1.763a.566.566,0,0,0-.591.433.858.858,0,0,0-.019.206q0,3.666,0,7.331a.581.581,0,0,0,.642.644H7.971a.583.583,0,0,0,.645-.642c0-.566,0-1.131,0-1.7a.575.575,0,0,1,.467-.6.569.569,0,0,1,.664.432.935.935,0,0,1,.019.195q0,.843,0,1.686a1.729,1.729,0,0,1-1.78,1.779q-3.106,0-6.211,0A1.725,1.725,0,0,1,0,24.571q0-1.841,0-3.683",
    transform: "translate(0 -14.724)",
    fill: "#2e343d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M72.92,8.516c-.246,0-.493,0-.739,0a.571.571,0,0,1-.61-.585c-.007-.481-.007-.962.011-1.443A2.9,2.9,0,0,1,72.472,4.5Q74.391,2.578,76.318.66a2.2,2.2,0,0,1,3.236,2.97q-.092.1-.191.2Q77.494,5.7,75.625,7.572a3.069,3.069,0,0,1-2.278.945H72.92m-.2-1.152c.221,0,.424,0,.628,0a1.924,1.924,0,0,0,1.468-.606q1.2-1.209,2.407-2.408a.384.384,0,0,1,.088-.056l-1.5-1.5a.237.237,0,0,0-.024.02Q74.527,4.073,73.271,5.33a1.9,1.9,0,0,0-.45.717,4.313,4.313,0,0,0-.1,1.318M76.642,1.92l1.5,1.5c.154-.155.325-.316.484-.488a1.349,1.349,0,0,0,.2-.282,1.047,1.047,0,0,0-.195-1.194,1,1,0,0,0-1.2-.193,7.719,7.719,0,0,0-.791.654",
    transform: "translate(-68.261 0)",
    fill: "#2e343d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8fe5fe7d2ee30f24cf0249786da13ff4.svg";
export { ForwardRef as ReactComponent };